













































































































import { Mixins } from "vue-mixin-decorator";
import moment from "moment";
import { Component, Prop } from "vue-property-decorator";
import { Action, Mutation, Getter } from "vuex-class";
import GeneralMixin from "@/mixin";
import { ISite, ISiteCreateRequest, ISiteUpdateRequest } from "@/types/site";

@Component({
  components: {}
})
export default class extends Mixins<GeneralMixin>(GeneralMixin) {
  @Action("site/get")
  public getSite!: (id: number) => void;

  @Action("site/create")
  public create!: (params: ISiteCreateRequest) => boolean;

  @Action("site/update")
  public update!: (data: {
    site_id: number;
    params: ISiteUpdateRequest;
  }) => boolean;

  @Getter("site/single")
  public site!: ISite;

  @Mutation("site/clear")
  public clear!: () => void;

  @Mutation("setLoading")
  public setLoading!: (flg: boolean) => void;

  @Prop({ default: 0 })
  public site_id!: number;

  public valid = true;
  public lazy = false;

  public startValidation: Array<boolean | string> = [true];
  public endValidation: Array<boolean | string> = [true];

  public span_validate() {
    this.startValidation = [true];
    this.endValidation = [true];
    if (!this.params.span_start || !this.params.span_end) {
      return;
    }
    const diff = moment(this.params.span_start).diff(this.params.span_end, "d");
    if (diff > 0) {
      this.startValidation = ["開始日は終了日より前にしてください"];
      this.endValidation = ["終了日は開始日より後にしてください"];
    }
  }

  public rules = {
    name: [
      (v: string) => !!v || "現場名は必須です",
      (v: string) =>
        (v && v.length <= 30) || "現場名は30文字以下で入力してください"
    ],
    address: [
      (v: string) => !!v || "住所は必須です",
      (v: string) =>
        (v && v.length <= 191) || "住所は191文字以下で入力してください"
    ]
  };

  public params: ISiteCreateRequest = {
    name: "",
    users: [],
    address: "",
    span_start: "",
    span_end: ""
  };

  public menu = {
    span_start: false,
    span_end: false
  };

  public async created() {
    const site_id = Number(this.$route.params.site_id);
    this.clear();
    // 新規作成
    if (!site_id) {
      return;
    }

    // 更新
    await this.getSite(site_id);
    this.setDefault();
  }

  private setDefault() {
    this.params.name = this.site.name;
    this.params.address = this.site.address;
    this.params.span_start = this.date_format(this.site.span_start);
    this.params.span_end = this.date_format(this.site.span_end);
  }

  public async submit() {
    if (this.site.id) {
      await this.update({ site_id: this.site.id, params: this.params });
    } else {
      await this.create(this.params);
    }
    this.$router.go(-1);
  }
}
